// Source: https://docs.oracle.com/cd/E29584_01/webhelp/mdex_basicDev/src/rbdv_chars_mapping.html

export const isoLatin1Character = {
    /* eslint-disable */
    'À': 'a',
    'Á': 'a',
    'Â': 'a',
    'Ã': 'a',
    'Ä': 'a',
    'Å': 'a',
    'Æ': 'a',
    'Ç': 'c',
    'È': 'e',
    'É': 'e',
    'Ê': 'e',
    'Ë': 'e',
    'Ì': 'i',
    'Í': 'i',
    'Î': 'i',
    'Ï': 'i',
    'Ð': 'd',
    'Ñ': 'n',
    'Ò': 'o',
    'Ó': 'o',
    'Ô': 'o',
    'Õ': 'o',
    'Ö': 'o',
    'Ø': 'o',
    'Ù': 'u',
    'Ú': 'u',
    'Û': 'u',
    'Ü': 'u',
    'Ý': 'y',
    'Þ': 'p',
    'ß': 's',
    'à': 'a',
    'á': 'a',
    'â': 'a',
    'ã': 'a',
    'ä': 'a',
    'å': 'a',
    'æ': 'a',
    'ç': 'c',
    'è': 'e',
    'é': 'e',
    'ê': 'e',
    'ë': 'e',
    'ì': 'i',
    'í': 'i',
    'î': 'i',
    'ï': 'i',
    'ð': 'e',
    'ñ': 'n',
    'ò': 'o',
    'ó': 'o',
    'ô': 'o',
    'õ': 'o',
    'ö': 'o',
    'ø': 'o',
    'ù': 'u',
    'ú': 'u',
    'û': 'u',
    'ü': 'u',
    'ý': 'y',
    'þ': 'p',
    'ÿ': 'y',
    /* eslint-enable */
};
